var React = require('react');

function ProjectsInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"filter":"url(#filter0_f_1912_3854)","key":0},React.createElement("ellipse",{"cx":"35.5","cy":"36","rx":"34.5","ry":"35","fill":"#2154B2"})),React.createElement("defs",{"key":1},React.createElement("filter",{"id":"filter0_f_1912_3854","x":"0.717699","y":"0.717699","width":"69.5646","height":"70.5646","filterUnits":"userSpaceOnUse","colorInterpolationFilters":"sRGB"},[React.createElement("feFlood",{"floodOpacity":"0","result":"BackgroundImageFix","key":0}),React.createElement("feBlend",{"mode":"normal","in":"SourceGraphic","in2":"BackgroundImageFix","result":"shape","key":1}),React.createElement("feGaussianBlur",{"stdDeviation":"0.14115","result":"effect1_foregroundBlur_1912_3854","key":2})]))]);
}

ProjectsInline.defaultProps = {"width":"70","height":"70","viewBox":"-15 -15 100 100","fill":"none"};

module.exports = ProjectsInline;

ProjectsInline.default = ProjectsInline;
